$( document ).ready(function() {
    $('.fader').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        arrows: false,
        cssEase: 'linear',
        appendDots:$('.right-over-ons'),
        breakpoint: 480,
        autoplay: true,
        autoplaySpeed: 5000
    });

    $('.fader2').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        arrows: false,
        cssEase: 'linear',
        appendDots:$('.left-catering'),
        autoplay: true,
        autoplaySpeed: 5000,
    });

    $('.navbar-nav>a').on('click', function(){
        console.log('a');
        $('.navbar-collapse').collapse('hide');
    });

    var myFullpage = new fullpage('#fullpage', {
        menu: '#menu',
        lazyLoad: true,
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        anchors: ['home', 'over-ons', 'eten-en-drinken', 'catering', 'agenda', 'campus', 'contact', 'footer'],
        touchSensitivity: 3,
        responsiveWidth: '991',
        onLeave: function(origin, destination, direction){
            var leavingSection = this;

            //after leaving section 2
            if(origin.index == 0 && direction =='down'){
                $(".navbar").removeClass("top");
                $(".uil--top").removeClass("show");
            }

            else if(origin.index == 1 && direction == 'up'){
                $(".navbar").addClass("top");
                $(".uil--top").addClass("show");
            }
        }
    });

    $(function () {
        $('#datetimepicker4').datetimepicker({
            locale: 'nl',
            format: 'L'
        });
    });

    $(function () {
        $('#datetimepicker3').datetimepicker({
            locale: 'nl',
            format: 'LT'
        });
    });

    $(function(){
        $('#contactform').submit('click', function(e){
            e.preventDefault();
            $.ajax({
                url: '/includes/contact.php', //this is the submit URL
                type: 'POST', //or POST
                data: $('#contactform').serialize(),
                success: function(data){
                    $(".modal-body").html('Bedankt voor je bericht. We zullen z.s.m. contact met je opnemen.');
                    $(".contact-btn").hide();
                }
            });
        });



        $('#reserveerform').submit('click', function(e){
            e.preventDefault();
            var resdate = $("input[name=datum]").val();
            var restime = $("input[name=tijd]").val();



            var reservation = moment(resdate + " " + restime, 'DD/MM/YYYY HH:mm');

            var weekday = moment(reservation).format('E');
            var tijd = moment(restime+':00', 'hh:mm:ss');

            var beforeTime = moment('12:00:00', 'hh:mm:ss');
            var afterTime = moment('15:00:00', 'hh:mm:ss');


            reservation = moment(reservation).format('DD/MM/YYYY HH:mm');
            var CurrentDate = moment().format('DD/MM/YYYY HH:mm');


            var duration = moment.duration(moment(reservation,"DD/MM/YYYY HH:mm:ss").diff(moment(CurrentDate,"DD/MM/YYYY HH:mm:ss")));
            var hours = duration.asHours();

            //maandag
            var startTimeMonday = moment('11:00:00', 'hh:mm:ss');
            var endTimeMonday = moment('18:00:00', 'hh:mm:ss');
            var startTimeTuesday = moment('09:00:00', 'hh:mm:ss');
            var endTimeTuesday = moment('18:00:00', 'hh:mm:ss');
            var startTimeWednesday = moment('09:00:00', 'hh:mm:ss');
            var endTimeWednesday = moment('22:00:00', 'hh:mm:ss');
            var startTimeSaturday = moment('10:00:00', 'hh:mm:ss');
            var endTimeSaturday = moment('22:00:00', 'hh:mm:ss');
            var startTimeSunday = moment('11:00:00', 'hh:mm:ss');
            var endTimeSunday = moment('18:00:00', 'hh:mm:ss');

            if((weekday == "1" && tijd.isBetween(startTimeMonday,endTimeMonday)) || (weekday == "2" && tijd.isBetween(startTimeTuesday,endTimeTuesday))
            || ((weekday == "3" || weekday == "4" || weekday == "5") && tijd.isBetween(startTimeWednesday,endTimeWednesday))
            || (weekday == "6" && tijd.isBetween(startTimeSaturday,endTimeSaturday))
            || (weekday == "7" && tijd.isBetween(startTimeSunday,endTimeSunday))) {



            if (tijd.isBetween(beforeTime, afterTime) && (weekday == "6" || weekday == "7") && ($("input[name=aantalpersonen]").val() < 6)) {



                $( ".res-error" ).html('<p>Helaas nemen wij alleen reserveringen op zaterdag en zondag tussen 12:00 en 15:00 vanaf 6 personen.</p>');


            }
            else {
                //console.log(hours);
                if(hours >= 12) {
                    $.ajax({
                        url: '/includes/reserveer.php', //this is the submit URL
                        type: 'POST', //or POST
                        data: $('#reserveerform').serialize(),
                        success: function(data){
                            $(".modal-body").html('Bedankt voor je reservering. We zullen z.s.m. contact met je opnemen.');
                            $(".btn-reserveren").hide();
                        }
                    });
                }
                else {
                    $( ".res-error" ).html('<p>Helaas nemen wij alleen reserveringen aan die minimaal 12uur van te voren zijn gemaakt.</p>');
                }



            }

            }
            else {
          
                $( ".res-error" ).html('<p>Helaas valt deze reservering buiten onze openingstijden. Maak a.u.b. een reservering binnen onze openingstijden.</p>');

            }

        });
    });
});